// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__5J8VP","notes":"Notes_notes__1L1Ta","note":"Notes_note__jidSE","markdown":"Notes_markdown__1Jb3r"};